import { UserManagementService } from './service/user-management.service';
import { Component, OnInit, inject } from '@angular/core';
import { LoggerService } from './logger.service';
import { IdleTimeoutService } from './service/idle-timeout.service';
import { Router, RouterOutlet } from '@angular/router';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: true,
  imports: [RouterOutlet],
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'GenAI-Smith';

    private usermanagementService = inject(UserManagementService);
  private idleTimeoutService = inject(IdleTimeoutService);
  private router = inject(Router);

  constructor() {

    // Start the idle timeout service when the app initializes
    const currentPath = this.router.url;

    // Only start idle timeout if not on login page
    if (!currentPath.includes('/login')) {
      this.idleTimeoutService.startWatching();
    }
  }

  // Method to handle the logout event from NavbarComponent
  handleLogout() {
    this.usermanagementService.logout();  // Calls the shared logout logic
  }
}
